export const SHOP_CONFIG = 'SHOP_CONFIG'
export const INVOICE = 'INVOICE'
export const WECHATPAYSHOW = 'WECHATPAYSHOW'


// WEBPACK FOOTER //
// ./src/store/mutation-types.js